import {Injectable} from '@angular/core';
import {UserDetailModel} from '../dto/user-detail.model';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() {
  }

  setUser(user) {

    window.sessionStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): UserDetailModel {
    return JSON.parse(window.sessionStorage.getItem('user'));
  }
}
